import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("dk_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(e) {
    const detail = e?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((x) => (x?.msg ? x.msg : JSON.stringify(x)))
            .filter(Boolean)
            .join(", ");
    }
    return "Terjadi kesalahan. Silakan coba lagi.";
}

export default api;
